import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../share-components/AppContext';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_NOT_FOUND, ROUTE_PURCHASE_EDIT, ROUTE_PURCHASE_LIST, ROUTE_PURCHASE_PRODUCT } from '../../constants/routeConstants';
import { Button, Card } from 'react-bootstrap';
import { customStorage, formatDateTime, getPayloadData, isNullOrEmptyString } from '../../services/UtilityService';
import AlertDialog from '../../share-components/AlertDialog';
import { cancelledPurchasedItem, getPurchasedDetails, receivedPurchasedItem } from '../../services/ManagementService';
import ConfirmDialog from '../../share-components/ConfirmDialog';
import FormTitle from '../../share-components/FormTitle';
import noImage from '../../assets/No_Image_Available.jpg';
import { SERVER_ERROR_MESSAGE, TOKEN_SESSION_KEY } from '../../constants/commonConstants';

const PurchaseDetails = () => {

    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);

    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const { purchaseId } = useParams();
    const [purchaseInfo, setPurchaseInfo] = useState(null);
    const [itemInfo, setItemInfo] = useState(null);
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState(null);
    const [actionButton, setActionButton] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    const navigate = useNavigate();

    const btnActions = {
        received: "received",
        cancelled: "cancelled"
    }

    const fetchPurchasedDetails = async () => {

        if ((parseInt(purchaseId) || 0) <= 0) {
            navigate(ROUTE_NOT_FOUND);
        }
        setLoading(true);
        try {
            const response = await getPurchasedDetails(purchaseId);
            setPurchaseInfo(response?.purchasedInfo);
            const convertedItemInfo = (response?.purchasedItems || []).map((itemInfo) => ({
                showData: getShowData(itemInfo)
            }));

            setItemInfo(convertedItemInfo);
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setRouteNaviData("PURCHASE >> PURCHASE DETAILS");
        fetchPurchasedDetails();
    }, []);

    const onReceivedClick = () => {
        setActionButton(btnActions.received);
        setConfirmMessage("Are you sure you received this purchased item(s)?");
    }

    const onCancelledClick = () => {
        setActionButton(btnActions.cancelled);
        setConfirmMessage("Are you sure to cancel this purchased item(s)?");
    }

    const handleSuccessDialogClose = async () => {
        setSuccessMessage(null);
        if (actionButton === btnActions.cancelled) {
            navigate(ROUTE_PURCHASE_LIST);
        } else {
            await fetchPurchasedDetails();
        }
    }

    const handleAction = async () => {
        const purchaseIdNumber = parseInt(purchaseId) || 0;
        if (purchaseIdNumber <= 0) {
            return;
        }
        setConfirmMessage(null);
        setLoading(true);
        try {
            if (actionButton === btnActions.received) {
                await receivedPurchasedItem(purchaseIdNumber);
                setSuccessMessage("Your purchase received status is successfully updated.");
            } else if (actionButton === btnActions.cancelled) {
                await cancelledPurchasedItem(purchaseIdNumber);
                setSuccessMessage("Successfully cancelled the purchased item(s).")
            } else {
                setActionButton(null);
                setConfirmMessage(null);
            }
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {
            Header: 'Order Products',
            accessor: 'showData',
            className: 'no-selectable-text',
            disableSortBy: true,
            style: {
                minWidth: "320px",
                // maxWidth: "400px"
            },
            Cell: ({ row }) => row.original.showData?.jsx,
        }
    ];

    const getShowData = (pcItem) => {
        return {
            jsx: (
                <div>
                    <div style={{
                        fontWeight: '600',
                        display: 'flex',
                    }}>
                        <div style={{ flex: "1", paddingRight: "10px" }}>
                            <div><i className='bi bi-award'></i> {pcItem?.brandName}</div><hr className='m-0' />
                            <div><i className='bi bi-box'></i> {pcItem?.productName}</div><hr className='m-0' />
                            <div><i className='bi bi-tags'></i> {pcItem?.categoryName}</div><hr className='m-0' />
                            {(!isNullOrEmptyString(pcItem?.size) || !isNullOrEmptyString(pcItem.color)) &&
                                <>
                                    <div>
                                        <i className='bi bi-palette'></i> {!isNullOrEmptyString(pcItem.color) && <span>[{pcItem.color}]</span>}{!isNullOrEmptyString(pcItem?.size) && <span>[{pcItem.size}]</span>}

                                    </div><hr className='m-0' />
                                </>
                            }
                            <div><i className='bi bi-bag-plus'></i> x({pcItem?.quantity})</div><hr className='m-0' />
                            <div><i className='bi bi-cash'></i><span> {(pcItem.amount || 0)}¥</span></div>
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                            <img
                                src={pcItem?.productPicture ? `data:image/jpeg;base64,${pcItem?.productPicture}` : noImage}
                                alt="picture"
                                className="img-thumbnail"
                                style={{ width: "var(--orderProductPictureWidth)", height: "var(--orderProductPictureHeight)", objectFit: "cover" }}
                            />
                        </div>
                    </div>
                </div>
            ),
        };
    };

    return (
        <div id='createProductPage' style={{ paddingBottom: '50px' }}>
            <FormTitle title={"Purchase Details"} isCenter={true} />

            {isFirstLoaded && <>
                <Card style={{ padding: '10px', margin: '0 auto', maxWidth: '650px' }}>
                    <Card.Body className='pt-2'>
                        <div className="container">
                            <div className="">
                                <div style={{ maxWidth: "550px", margin: '0 auto' }}>
                                    <div className='mb-3 center-block-column' >
                                        {itemInfo.map((item, index) => (
                                            <div key={index} className='info-card'
                                            // style={{ animationDelay: `${index * 0.6}s` }}
                                            >
                                                {item.showData.jsx}
                                            </div>
                                        ))}
                                    </div>


                                    <div className="mb-1">
                                        <label className="custom-label">Purchased By</label>
                                        <div className="w-100 label-box main-description">
                                            {purchaseInfo?.purchasedBy}
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="custom-label">Purchased Date</label>
                                        <div className="w-100 label-box">
                                            {formatDateTime(purchaseInfo?.createdDateTime)}
                                        </div>
                                    </div>

                                    {(purchaseInfo?.createdDateTime !== purchaseInfo?.lastUpdatedDateTime) && <div className="mb-1">
                                        <label className="custom-label">Last Updated Date</label>
                                        <div className="w-100 label-box">
                                            {formatDateTime(purchaseInfo?.lastUpdatedDateTime)}
                                        </div>
                                    </div>}

                                    <div className="mb-1">
                                        <label className="custom-label">Total Quantity</label>
                                        <div className="w-100 label-box">
                                            {purchaseInfo?.totalQuantity}
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="custom-label">Subtotal Price</label>
                                        <div className="w-100 label-box">
                                            {purchaseInfo?.totalPurchasedAmount}¥
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="custom-label">Discount Price</label>
                                        <div className="w-100 label-box">
                                            {purchaseInfo?.discountAmount}¥
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="custom-label">Actual Purchased Price</label>
                                        <div className="w-100 label-box main-description">
                                            {purchaseInfo?.totalPurchasedAmount - purchaseInfo?.discountAmount}¥
                                        </div>
                                    </div>

                                    <div className="mt-3 form-check form-switch form-check-reverse text-start mb-2" >
                                        <label className="form-check-label custom-label">
                                            Received Product
                                            <input type="checkbox" checked={purchaseInfo?.receivedFlag === true} className="form-check-input ms-2" disabled />
                                        </label>
                                    </div>

                                    <div className="mb-1">
                                        <label className="custom-label">Shop Name</label>
                                        <div className="w-100 label-box">
                                            {purchaseInfo?.shopName}
                                        </div>
                                    </div>

                                    <div className="mb-1">
                                        <label className="custom-label">Comment</label>
                                        <div className="w-100 label-box input-area input-area">
                                            {purchaseInfo?.comment}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='floating-bottom-btn-group mt-2'>
                            <div className='floating-bottom-btn-grid'>
                                {purchaseInfo?.purchasedById === currentUser?.userId && purchaseInfo?.receivedFlag === false &&
                                    <Button
                                        className="appBtn w-100"
                                        type="button"
                                        variant="primary"
                                        onClick={onReceivedClick}
                                    >
                                        Received
                                    </Button>}
                                <Button
                                    className="appBtn w-100"
                                    type="button"
                                    variant="secondary"
                                    onClick={() => navigate(ROUTE_PURCHASE_LIST)}
                                >
                                    Go to Purchase List
                                </Button>
                                <Button
                                    className="appBtn w-100"
                                    type="button"
                                    variant="warning"
                                    onClick={() => navigate(`${ROUTE_PURCHASE_PRODUCT}`)}
                                >
                                    Add New Purchase
                                </Button>
                                {purchaseInfo?.purchasedById === currentUser?.userId && <Button
                                    className="appBtn w-100"
                                    type="button"
                                    variant="secondary"
                                    onClick={() => navigate(`${ROUTE_PURCHASE_EDIT}/${purchaseId}`)}
                                >
                                    Edit
                                </Button>}
                                {purchaseInfo?.purchasedById === currentUser?.userId &&
                                    <Button
                                        className="appBtn w-100"
                                        type="button"
                                        variant="danger"
                                        onClick={onCancelledClick}
                                    >
                                        Cancel Purchase
                                    </Button>}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <ConfirmDialog
                    dialogId='confirmDialog'
                    showDialog={!isNullOrEmptyString(confirmMessage)}
                    // title='Logout Dialog'
                    body={confirmMessage}
                    onConfirm={handleAction}
                    onCancel={() => { setActionButton(null); setConfirmMessage(null); }}
                />
                <AlertDialog
                    dialogId={'successDialog'}
                    showDialog={!isNullOrEmptyString(successMessage)}
                    body={successMessage}
                    onConfirm={handleSuccessDialogClose}
                />
            </>}

        </div>
    );
}

export default PurchaseDetails;